import { render, staticRenderFns, recyclableRender, components } from "./u-count-to.vue?vue&type=template&id=5d654407&scoped=true&"
var renderjs
import script from "./u-count-to.vue?vue&type=script&lang=js&"
export * from "./u-count-to.vue?vue&type=script&lang=js&"
import style0 from "./u-count-to.vue?vue&type=style&index=0&id=5d654407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d654407",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-count-to/u-count-to.vue"
export default component.exports